import { DEFAULT_SIGNED_IN_PATH } from '~/utils/post-sign-in-target';

// cas-0529: legacy /dashboard entry points land on Home, the
// same place sign-in sends a returning user.
export default defineNuxtRouteMiddleware(() => {
  return navigateTo(DEFAULT_SIGNED_IN_PATH, { replace: true });
});
